import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: string;
  email: string;
  role: 'client' | 'therapist' | 'corporate_hr' | 'admin';
  mfaEnabled?: boolean;
  preferredLanguage?: string;
  phone?: string;
  firstName?: string | null;
  lastName?: string | null;
}

interface Tokens {
  accessToken: string;
  refreshToken?: string;
  expiresIn?: number;
}

interface AuthState {
  user: User | null;
  tokens: Tokens | null;
  accessToken: string | null;
  setAuth: (user: User, accessToken: string) => void;
  setAuthWithTokens: (user: User, tokens: Tokens) => void;
  setAccessToken: (accessToken: string) => void;
  updateUser: (user: Partial<User> | null) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      tokens: null,
      accessToken: null,

      setAuth: (user, accessToken) => {
        set({ user, accessToken, tokens: { accessToken } });
      },

      setAuthWithTokens: (user, tokens) => {
        set({ user, tokens, accessToken: tokens.accessToken });
      },

      setAccessToken: (accessToken) => {
        set((state) => ({
          accessToken,
          tokens: state.tokens ? { ...state.tokens, accessToken } : { accessToken },
        }));
      },

      updateUser: (partial) => {
        if (!partial) return;
        set((state) => ({ user: state.user ? { ...state.user, ...partial } : null }));
      },

      logout: () => {
        set({ user: null, accessToken: null, tokens: null });
      },

      isAuthenticated: () => {
        return get().user !== null && get().accessToken !== null;
      },
    }),
    {
      name: 'lighthouse-auth',
      partialize: (state) => ({
        user: state.user,
      }),
    }
  )
);
